<template>
<tr>
    <td>
        <router-link :to="'/distribuidores/' + distribuidor.Id " class="nav-link">{{distribuidor.Nombre}}</router-link>
    </td>
    <td>{{distribuidor.Contacto}}</td>
    <td>{{distribuidor.Telefono}}</td>
    <td class="right-aligment">{{distribuidor.Comprados | quantity}}</td>
    <td class="right-aligment">{{distribuidor.Asignados | quantity}}</td>
    <td class="right-aligment">{{distribuidor.Disponibles | quantity}}</td>
    <td>{{distribuidor.Vigencia | fecha}}</td>
    <td style="text-align:center">
        <template v-if="distribuidor.Estatus">
          <span class="badge badge-success"><i style="margin-top: 0px;" class="fa fa-check"></i></span>
        </template>
        <template v-else>
          <span class="badge badge-danger"><i style="margin-top: 0px;" class="fa fa-close"></i></span>
        </template>
    </td>
    <td style="text-align:center">
        <a href="#"  v-b-tooltip.hover title="Editar distribuidor" @click.prevent="editar()"><i class="fa fa-edit"></i></a>
        <a href="#"  v-b-tooltip.hover title="Descargar excel" @click="exportExcel()">
          <template v-if="excelLoading == false"><i class="fa fa-download"></i></template>
          <template v-else><i class="fa-spin fa fa-spinner"></i></template>
        </a>
        <template v-if="distribuidor.Estatus">
          <a href="#" @click="abrirAsignador(distribuidor.Id)" v-b-tooltip.hover title="Asignar timbres"><i class="fa fa-plus"></i></a>
        </template>
    </td>
</tr>
</template>
<script>
import moment from 'moment'
import EventBus from '@/event-bus.js'
import Loader from '@/components/Loader'

export default {
  props: ['distribuidor'],
  components: {
    moment,
    Loader
  },
  data () {
    return {
      excelLoading: false,
      edit: false,
      errors: {},
      draft: {}
    }
  },
  computed: {
    disponibles () {
      return parseInt(this.draft.asignados) + parseInt(this.distribuidor.disponibles)
    }
  },
  filters: {
    quantity (quan) {
      return (typeof quan === 'undefined') ? quan : quan.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    fetchErrors (errors) {
      return (typeof errors === 'undefined') ? '' : (errors.length > 0) ? errors[0] : ''
    },
    fecha (asignacion) {
      let date = moment(asignacion).format('DD-MMM-YYYY')
      let res = date.split('-')
      res[1] = res[1].charAt(0).toUpperCase() + res[1].slice(1)
      return res.join('-')
    },
    toCapitalizeTitle (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
    }
  },
  methods: {
    abrirAsignador (id) {
      EventBus.$emit('abrirModalAsignar', {Id: id, Nombre: this.distribuidor.Nombre})
    },
    fetchDistribuidores: function () {
      let promise = this.$store.dispatch('fetchDistribuidores')
      promise.then(response => {
        this.$store.commit('distribuidores', response.data)
      })
    },
    changeStatus (Status) {
      this.draft.Estatus = Status
    },
    editar () {
      EventBus.$emit('OpenEditar', this.distribuidor)
      EventBus.$emit('disableOrderDistribuidores', true)
    },
    exportExcel () {
      this.excelLoading = true
      let promise = this.$store.dispatch('distribuidorExcel', this.draft)
      promise.then(response => {
        this.excelLoading = false
        window.open(response.data.url)
      })
    }
  },
  mounted () {
    let obj = Object.create(this.distribuidor)
    this.draft = obj
  }
}
</script>
<style>
  .nav-link {
    padding: 0px;
  }
  .edit-buttons button {
    width: 100%;
    margin: 5px 0px;
  }
  .form-control-invalid {
    border-color: red;
  }
  .form-control-feedback {
    color: red;
  }
</style>


// WEBPACK FOOTER //
// src/views/Distribuidores/row.vue